import React from 'react';
import { Link } from "react-router-dom";
import routes from 'src/routes';
import url from 'src/util/url';
import Page from 'src/components/Page';

function ApiPage() {
    return <Page header="API">
        <h2>Before you start</h2>
        <p>To begin using the BPOINT API, you will need a BPOINT Checkout or Enterprise facility. An Administrator or Manager (T1) user will need to create an API user by following the steps below:</p>
        <ol>
            <li>Login to the Merchant Back Office</li>
            <li>Navigate to Admin  &gt;&gt; User Management</li>
            <li>Click on Add New User</li>
            <li>Enter the User Name and Email Address</li>
            <li>Select the User Permission 'API'</li>
            <li>Enter your (Administrator/Manager(T1) user's) password</li>
            <li>Click on Create User</li>
        </ol>
        <p>Use the API user credentials, username and password, to begin developing with the API.</p>
        <h2>Introduction</h2>
        <p>
            The API offers a way of interfacing with the payment platform programmatically in a REST interface using HTTP over SSL.
            Requests are submitted to process transactions, create and update entities including tokens, and perform searches.
        </p>
        <p>
            Requests to the API are categorised by the different areas of functionality of the payment platform.
            The API supports transaction processing and token processing with other areas planned. Each area has its own URL endpoint.
            Different HTTP methods imply different operations, for example retrieval of information from the database is handled by the GET operation, while updates are handled by either POST or PUT requests as appropriate.
        </p>
        <p>
            API requests and responses are in JSON format.
            Documentation of the API is provided via the OpenApi format (previously known as Swagger), which can be <Link to={routes.api.spec}>viewed in a web format</Link>,
            or <a href={url.api("v5/swagger")}>downloaded</a> and viewed in external tools.
            Free tools like <a href="https://openapi-generator.tech/">OpenAPI Generator</a> can be used to generate client libraries.
        </p>
        <h2>Authentication</h2>
        <p>
            The API uses HTTP basic authentication.<br/>
            If your client supports basic authentication, you may simply supply the username as API user's username and your merchant number in the format: <code>apiUsername|merchantNumber</code>.<br/>
            If your client does not support basic authentication, you will need to send the <code>Authorization</code> header manually, see below for the format.
        </p>
        <h3>Authorization header format</h3>
        <p>
            Use an <code>Authorization</code> header to pass a base64 encoded string containing the API user credentials, prefixed with "Basic ".
        </p>
        <p>
            The string is formatted as follows:
        </p>
        <div>
            <code>username|merchantnumber:password</code>
        </div>
        <p>
            For example, the HTTP header for above credentials string is:
        </p>
        <div>
            <code>Authorization: Basic dXNlcm5hbWV8bWVyY2hhbnRudW1iZXI6cGFzc3dvcmQ=</code>
        </div>
        <p>
            The spelling of the header name is critical for correct authentication.
        </p>
    </Page>;
}

export default ApiPage;